export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.66667 4C5.19391 4 4 5.19391 4 6.66667V25.3333C4 26.8061 5.19391 28 6.66667 28H25.3333C26.8061 28 28 26.8061 28 25.3333V6.66667C28 5.19391 26.8061 4 25.3333 4H6.66667ZM24.9282 11.6239C25.4568 11.1112 25.4698 10.2671 24.9572 9.73847C24.4446 9.20983 23.6005 9.19684 23.0718 9.70947L13 19.4761L8.92819 15.5276C8.39955 15.015 7.55543 15.028 7.0428 15.5567C6.53017 16.0853 6.54316 16.9294 7.07181 17.442L12.0718 22.2905C12.589 22.792 13.411 22.792 13.9282 22.2905L24.9282 11.6239Z"
                fill="black"
            />
        </svg>
    );
}
